import * as React from 'react';
import { ButtonModifier } from '../../../infrastructure/helpers';
import DefaultButton from '../default-button/default-button';
import classnames from 'classnames';
import { IMultiSelectClosedPropsDerivedFromItemsList, makeMultiSelectInPopover } from './make-multi-select-in-popover';

type MultiSelectButtonProps = IMultiSelectClosedPropsDerivedFromItemsList & {
    text: string | object;
    className?: string;
    disabledButton?: boolean;
    onClick?: () => void;
};

/**
 * Render DefaultButton, with label, selectable through the SingleSelectList rendered in popover
 * change button look and feel based on popover being shown/hidden
 */
const MultiSelectButton = makeMultiSelectInPopover(
    React.forwardRef((props: MultiSelectButtonProps, ref: React.Ref<HTMLInputElement>) => {
        const { text, isOpen, className, onClick, disabledButton } = props;
        const modifiers: ButtonModifier[] = ['fat'];
        if (isOpen) {
           modifiers.push('confirm-safe');
        } else {
            modifiers.push('options');
        }

        return <DefaultButton
            modifier={modifiers}
            text={text}
            ref={ref}
            disabled={disabledButton}
            className={classnames(className, {'active': isOpen})}
            onClick={() => isOpen && onClick?.()}
        />;
    })
);

export { MultiSelectButton };
